import Tool from './Tool';
import Shortcut from '../utils/Shortcut';

class ToolBringToFront extends Tool {
  static toolName = 'Bring to front';
  static shortcut = new Shortcut('pageup,Cmd+]');

  static action({ controller, selection }) {
    selection.bringToFront();
    this.toolActionComplete({ controller });
  }

  static available({ controller, selection }) {
    if (selection?.type === 'comment') {
      return false;
    }

    return super.available({ controller, selection });
  }
}

export default ToolBringToFront;
